import Vue from "vue";
import App from "./App.vue";
import Vconsole from "vconsole";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";
import "./libs/element";
import "./libs/test";
import Comm from "@/comm";
import "./assets/css/base.scss";
Vue.config.productionTip = false;

//通用
Vue.use(Comm);
console.log("process.env.VUE_APP_DEBUG", process.env.VUE_APP_DEBUG);
if (process.env.VUE_APP_DEBUG == "1") {
  // new Vconsole();
}
import BottomTip from "./components/bottom-tip/index.vue";
import TableShow from "./components/table-show/index.vue";
Vue.component("bottom-tip", BottomTip);
Vue.component("table-show", TableShow);
import lang from "@/lang/index.js";
import locale from "element-ui/lib/locale";
locale.use(lang);
new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
